// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== 전역 ===== */
:root {
    --footer-max: 600px;
    --tabbar-bg: #fff;
    --inactive-icon: #aeb5bf;
    --active-fill: #ff6a63;
    --label: #262b33;
    --label-active: #e95454;
}

.footer {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 0;
    z-index: 100;
    width: 100%;
    max-width: var(--footer-max);
}

/* ===== 하단 탭바 ===== */
.main-tabbar {
    position: relative;
    background: var(--tabbar-bg);
    padding: 0px 18px 10px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 6px;
    align-items: end;
    box-shadow: 0 -2px 12px rgba(0, 0, 0, .08);
    overflow: visible;
    /* ⬅️ 볼록 영역이 위로 튀어나오도록 */
}

.main-tab {
    position: relative;
    /* ⬅️ 볼록 배경을 버튼 기준으로 그리기 */
    border: none;
    background: transparent;
    display: grid;
    justify-items: center;
    cursor: pointer;
    z-index: 1;
    /* 기본 컨텐츠가 볼록 배경 위에 오도록 */
}

/* === 볼록 튀어나오는 상단(활성일 때만) === */
.main-tab.active::before {
    content: "";
    position: absolute;
    left: 50%;
    top: -15px;
    /* ⬅️ 위로 살짝 튀어나오게 */
    transform: translateX(-50%);
    width: 80px;
    /* 볼록 너비 */
    height: 50px;
    /* 볼록 높이 */
    background: var(--tabbar-bg);
    border-top-left-radius: 999px;
    border-top-right-radius: 999px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 0;
    box-shadow: 0px -8px 12px rgba(0, 0, 0, .08);
}

/* ===== 라벨 ===== */
.main-tab-label {
    font-size: 13px;
    color: var(--label);
}

.main-tab-box {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    z-index: 1;
}

/* ===== 아이콘 베이스 ===== */
/* 비활성: 원형 배경 없음 */
.main-tab-icon {
    width: 45px;
    height: 45px;
    border-radius: 999px;
    background: transparent;
    /* 비활성: 원형 없음 */
    display: grid;
    place-items: center;
    color: var(--inactive-icon);
    transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
}

.main-tab-icon svg {
    font-size: 22px;
    /* 아이콘 크기 */
    line-height: 1;
}

/* 활성: 원형 배경 + 살짝 리프트 */
.main-tab.active .main-tab-icon {
    width: 50px;
    height: 50px;
    /* background: var(--active-fill); */
    color: #fff;
    /* 아이콘 컬러 */
    /* box-shadow: 0 6px 14px rgba(255, 106, 99, .28); */
    transform: translateY(-6px);
}

.main-tab.active .main-tab-icon.list {
    background: var(--active-fill);
}

.main-tab.active .main-tab-icon.search,
.main-tab.active .main-tab-icon.qr {
    background: #1C6DD0;
}

.main-tab.active .main-tab-icon.more {
    background: #000;
}

.main-tab.active .main-tab-label.list {
    color: var(--label-active);
    font-weight: 700;
}

.main-tab.active .main-tab-label.search,
.main-tab.active .main-tab-label.qr {
    color: #1C6DD0;
    font-weight: 700;
}

.main-tab.active .main-tab-label.more {
    color: #000;
    font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/Pages/nav/nav.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,mBAAmB;IACnB,iBAAiB;IACjB,wBAAwB;IACxB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,SAAS;IACT,2BAA2B;IAC3B,SAAS;IACT,YAAY;IACZ,WAAW;IACX,4BAA4B;AAChC;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,gBAAgB;IAChB,0CAA0C;IAC1C,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,UAAU;IACV,yBAAyB;AAC7B;;AAEA,gCAAgC;AAChC;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,UAAU;IACV,YAAY;IACZ,UAAU;IACV,4BAA4B;IAC5B,6BAA6B;IAC7B,8BAA8B;IAC9B,4BAA4B;IAC5B,6BAA6B;IAC7B,UAAU;IACV,4CAA4C;AAChD;;AAEA,mBAAmB;AACnB;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;IACX,UAAU;AACd;;AAEA,wBAAwB;AACxB,kBAAkB;AAClB;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,2EAA2E;AAC/E;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,WAAW;IACX,WAAW;IACX,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;;IAEI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB","sourcesContent":["/* ===== 전역 ===== */\r\n:root {\r\n    --footer-max: 600px;\r\n    --tabbar-bg: #fff;\r\n    --inactive-icon: #aeb5bf;\r\n    --active-fill: #ff6a63;\r\n    --label: #262b33;\r\n    --label-active: #e95454;\r\n}\r\n\r\n.footer {\r\n    position: fixed;\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    bottom: 0;\r\n    z-index: 100;\r\n    width: 100%;\r\n    max-width: var(--footer-max);\r\n}\r\n\r\n/* ===== 하단 탭바 ===== */\r\n.main-tabbar {\r\n    position: relative;\r\n    background: var(--tabbar-bg);\r\n    padding: 0px 18px 10px;\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 6px;\r\n    align-items: end;\r\n    box-shadow: 0 -2px 12px rgba(0, 0, 0, .08);\r\n    overflow: visible;\r\n    /* ⬅️ 볼록 영역이 위로 튀어나오도록 */\r\n}\r\n\r\n.main-tab {\r\n    position: relative;\r\n    /* ⬅️ 볼록 배경을 버튼 기준으로 그리기 */\r\n    border: none;\r\n    background: transparent;\r\n    display: grid;\r\n    justify-items: center;\r\n    cursor: pointer;\r\n    z-index: 1;\r\n    /* 기본 컨텐츠가 볼록 배경 위에 오도록 */\r\n}\r\n\r\n/* === 볼록 튀어나오는 상단(활성일 때만) === */\r\n.main-tab.active::before {\r\n    content: \"\";\r\n    position: absolute;\r\n    left: 50%;\r\n    top: -15px;\r\n    /* ⬅️ 위로 살짝 튀어나오게 */\r\n    transform: translateX(-50%);\r\n    width: 80px;\r\n    /* 볼록 너비 */\r\n    height: 50px;\r\n    /* 볼록 높이 */\r\n    background: var(--tabbar-bg);\r\n    border-top-left-radius: 999px;\r\n    border-top-right-radius: 999px;\r\n    border-bottom-left-radius: 0;\r\n    border-bottom-right-radius: 0;\r\n    z-index: 0;\r\n    box-shadow: 0px -8px 12px rgba(0, 0, 0, .08);\r\n}\r\n\r\n/* ===== 라벨 ===== */\r\n.main-tab-label {\r\n    font-size: 13px;\r\n    color: var(--label);\r\n}\r\n\r\n.main-tab-box {\r\n    background: #fff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    z-index: 1;\r\n}\r\n\r\n/* ===== 아이콘 베이스 ===== */\r\n/* 비활성: 원형 배경 없음 */\r\n.main-tab-icon {\r\n    width: 45px;\r\n    height: 45px;\r\n    border-radius: 999px;\r\n    background: transparent;\r\n    /* 비활성: 원형 없음 */\r\n    display: grid;\r\n    place-items: center;\r\n    color: var(--inactive-icon);\r\n    transition: transform .18s ease, box-shadow .18s ease, background .18s ease;\r\n}\r\n\r\n.main-tab-icon svg {\r\n    font-size: 22px;\r\n    /* 아이콘 크기 */\r\n    line-height: 1;\r\n}\r\n\r\n/* 활성: 원형 배경 + 살짝 리프트 */\r\n.main-tab.active .main-tab-icon {\r\n    width: 50px;\r\n    height: 50px;\r\n    /* background: var(--active-fill); */\r\n    color: #fff;\r\n    /* 아이콘 컬러 */\r\n    /* box-shadow: 0 6px 14px rgba(255, 106, 99, .28); */\r\n    transform: translateY(-6px);\r\n}\r\n\r\n.main-tab.active .main-tab-icon.list {\r\n    background: var(--active-fill);\r\n}\r\n\r\n.main-tab.active .main-tab-icon.search,\r\n.main-tab.active .main-tab-icon.qr {\r\n    background: #1C6DD0;\r\n}\r\n\r\n.main-tab.active .main-tab-icon.more {\r\n    background: #000;\r\n}\r\n\r\n.main-tab.active .main-tab-label.list {\r\n    color: var(--label-active);\r\n    font-weight: 700;\r\n}\r\n\r\n.main-tab.active .main-tab-label.search,\r\n.main-tab.active .main-tab-label.qr {\r\n    color: #1C6DD0;\r\n    font-weight: 700;\r\n}\r\n\r\n.main-tab.active .main-tab-label.more {\r\n    color: #000;\r\n    font-weight: 700;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
